import React from "react";
import Label from "components/general/Label"
import { arraysEqual } from 'helpers/utils'
import { useViewport } from 'components/general/useViewPort'


export const TableExpanded = React.memo((props) => {
    const { row } = props;
    const { officials } = props;
    const { breakPoint } = useViewport();
    const isMobile = (breakPoint === "xs" || breakPoint === "sm")

    return (
        <table className="table table-split">
            <thead>
                <tr>
                    <th className="text-end"><Label data="HeaderWave" /></th>
                    {
                      row?.extendedResults && row?.extendedResults.find(res => res.er_code === 'WAVE' && res.er_pos === "1")?.extensions.map((val, key) => {
                        let official = officials.find( off => off.function.functionCode === val.ere_pos );

                            return(
                                <th key={`th_judge_${row.participant.code}_${official.order}`} className="text-end">{isMobile ? official.function.functionCode : official.function.description}</th>
                            )
                    	})
                    }         
                    <th className="text-end"><Label data={isMobile ? "HeaderAvg" : "HeaderAverageDesc"} /></th>
                    <th className="d-none d-sm-table-cell text-end"><Label data="HeaderScoringWaves" /></th>
                </tr>
            </thead>
            <tbody>

				{row?.extendedResults && row?.extendedResults.filter(res => res.er_code === 'WAVE')?.map((extended, index) => {

                    return (
                        <tr key={`row_${row.participant.code}_${index}`}>
                            <td className="text-end fw-bold">{extended.er_pos}</td>
                            {
                                extended?.extensions.map((extension, index) => {
                                    return(
                                        <td key={`judge_${row.participant.code}_${extension.ere_pos}_${index}`} className="text-end">{extension.ere_value}</td>
                                    )
                                })
                            }   
                            <td className={(extended.er_arrive) ? 'text-end fw-bold' : 'text-end'}>
                                {extended.er_value}
                            </td>
                            <td className="d-none d-sm-table-cell text-end fw-bold">
                                {(extended.er_arrive) ? extended.er_value : ''}
                            </td>
                        </tr>
                    )
                })}
            </tbody>

        </table>
    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps.row, nextProps.row)
    )
});